import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { AboutIntro } from '@/components/about/about-intro'
import { AboutPhilosophy } from '@/components/about/about-philosophy'
import { AboutFounders } from '@/components/about/about-founders'
import { AboutProcess } from '@/components/about/about-process'
import { AboutCommitments } from '@/components/about/about-commitments'

const About: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='About us'
                description='Two dermatologists, five actives, and a hard ceiling on what goes in the jar. How Nuvéa
                started and how it is made.'
                ogImage='/images/about-portrait.png'
            />

            <AboutIntro />
            <AboutPhilosophy />
            <AboutFounders />
            <AboutProcess />
            <AboutCommitments />
        </Layout>
    )
}

export default About
